module.exports = __webpack_public_path__ + "static/media/NR-Raghavan.1abb8351.jpg";